'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dataCapsule = require('data-capsule');

var _workerStrategy = require('./workerStrategy.js');

var _workerStrategy2 = _interopRequireDefault(_workerStrategy);

var _consts = require('./applications/consts.js');

var _utils = require('./utils/utils');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _cartItemsStatuses = require('wix-art-store-3rd-party/dist/src/sdk/cartItemsStatuses');

var _cartItemsStatuses2 = _interopRequireDefault(_cartItemsStatuses);

var _WixSdkWrapper = require('photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartApi = function () {
  function CartApi(namespace, instance) {
    (0, _classCallCheck3.default)(this, CartApi);

    this.namespace = namespace;
    this.instance = instance;
    // if (utils.isDev()) {
    var strategy = new _workerStrategy2.default();
    this.dataStorage = new _dataCapsule.DataCapsule({
      strategy: strategy,
      namespace: namespace
    });
  }

  (0, _createClass3.default)(CartApi, [{
    key: 'addToCart',
    value: function addToCart(uuid, mediaUrl, galleryId, providerId, quantity, isDemo, metadata, styleId) {
      var _this = this;

      var newItem = {
        uuid: uuid,
        mediaUrl: mediaUrl,
        galleryId: galleryId,
        providerId: providerId,
        quantity: quantity,
        isDemo: isDemo,
        metadata: metadata,
        styleId: styleId,
        status: _cartItemsStatuses2.default.OK,
        timestamp: new Date().getTime()
      };

      return this.setItem(uuid, newItem).then(function () {
        _this.notifyCartChange();
        return _promise2.default.resolve(newItem);
      });
    }
  }, {
    key: 'updateItemsValidation',
    value: function updateItemsValidation(arrItems) {
      var _this2 = this;

      var validationRequestPromise = this._getInvalidItemsForDownload(arrItems);
      return validationRequestPromise.then(function (arrInvalidCartItems) {
        _this2._setInvalidItems(arrInvalidCartItems);
      });
    }
  }, {
    key: 'removeFromCart',
    value: function removeFromCart(uuid) {
      var _this3 = this;

      return this.dataStorage.removeItem(uuid).then(function () {
        _this3.notifyCartChange();
      });
    }
  }, {
    key: 'notifyCartChange',
    value: function notifyCartChange() {
      if (_windowWrapper2.default.Wix) {
        _WixSdkWrapper2.default.PubSub.publish(_consts.storePubSub.refreshCart, {}, true);
      }
    }
  }, {
    key: 'clearCart',
    value: function clearCart() {
      var _this4 = this;

      if (_utils.utils.isStoreGallery()) {
        return this.getCartItems('*').then(function (arrItems) {
          var arrPromises = [];
          arrItems.forEach(function (item) {
            var uuid = item.uuid;

            arrPromises.push(_this4.dataStorage.removeItem(uuid));
          });

          return _promise2.default.all(arrPromises);
        }).then(function () {
          _this4.notifyCartChange();
        });
      }
    }
  }, {
    key: 'setItem',
    value: function setItem(uuid, item) /* 24 hours */{
      var expiration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 86400;

      return this.dataStorage.setItem(uuid, item, {
        expiration: expiration
      });
    }
  }, {
    key: 'updateCartItem',
    value: function updateCartItem(uuid, metadata, quantity) {
      var _this5 = this;

      return this.dataStorage.getItem(uuid).then(function (cartItem) {
        var returnPromise = null;
        if (cartItem) {
          cartItem.metadata = metadata || cartItem.metadata;
          cartItem.quantity = quantity || cartItem.quantity;
          returnPromise = _this5.setItem(uuid, cartItem).then(function () {
            _this5.notifyCartChange();
          });
        } else {
          returnPromise = _promise2.default.reject('Item not found');
        }
        return returnPromise;
      });
    }
  }, {
    key: 'getCartItemsCount',
    value: function getCartItemsCount(arrItems) {
      var count = arrItems.reduce(function (previousCount, cartItem) {
        return previousCount + cartItem.quantity;
      }, 0);
      return count;
    }
  }, {
    key: 'getCartItems',
    value: function getCartItems(connectedProviderId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!connectedProviderId) {
        var message = 'Can\'t get cart items without providerId';
        console.error(message);
        throw message;
      }

      try {
        return this.dataStorage.getAllItems().then(function (objCartItems) {
          var cartItems = [];
          var itemUUID = options.uuid;
          // eslint-disable-next-line guard-for-in
          for (var cartItemUuid in objCartItems) {
            var cartItemCandidate = objCartItems[cartItemUuid];
            var uuid = cartItemCandidate.uuid,
                providerId = cartItemCandidate.providerId;

            var isUUIDValid = !itemUUID || itemUUID === uuid;
            var isSameProviderId = !connectedProviderId || connectedProviderId === providerId || connectedProviderId === '*';
            var shouldAddItem = isUUIDValid && isSameProviderId;

            if (shouldAddItem) {
              var cartItem = objCartItems[uuid];
              cartItems.push(cartItem);
            }
          }

          return cartItems.sort(function (item1, item2) {
            var item1Timestamp = item1.timestamp || 0;
            var item2Timestamp = item2.timestamp || 0;
            return item1Timestamp - item2Timestamp;
          });
        });
      } catch (error) {
        console.error('CartApi - getCartItems - ERROR:', error);
      }
    }
  }, {
    key: 'containsDemoItems',
    value: function containsDemoItems(connectedProviderId) {
      return this.getCartItems(connectedProviderId).then(function (items) {
        return items.filter(function (item) {
          return item.isDemo;
        });
      }).then(function (demoItems) {
        return demoItems.length > 0;
      });
    }
  }, {
    key: 'countCartForms',
    value: function countCartForms() {
      var cartFormCount = 0;
      for (var i = 0; i < _windowWrapper2.default.top.frames.length; i++) {
        var frame = _windowWrapper2.default.top.frames[i];
        try {
          if (frame.location.href.indexOf('cart-form') !== -1) {
            cartFormCount++;
          }
        } catch (e) {}
      }

      return cartFormCount;
    }
  }, {
    key: 'createCartForm',
    value: function createCartForm() {
      if (_utils.utils.isStoreGallery()) {
        var cartFormCount = this.countCartForms();
        if (!cartFormCount) {
          if (_WixSdkWrapper2.default.Utils.getViewMode() === 'site' || _WixSdkWrapper2.default.Utils.getViewMode() === 'preview') {
            _WixSdkWrapper2.default.openPopup(_windowWrapper2.default.location.origin + '/cart-form.html?isStore=true', '0%', '100%', {
              origin: _WixSdkWrapper2.default.WindowOrigin.FIXED,
              placement: _WixSdkWrapper2.default.WindowPlacement.CENTER
            }, null, _WixSdkWrapper2.default.Theme.BARE);
          }
        }
      }
    }
  }, {
    key: 'showCart',
    value: function showCart() {
      _WixSdkWrapper2.default.PubSub.publish('showCart', {}, false);
    }
  }, {
    key: 'hideCart',
    value: function hideCart(data) {
      _WixSdkWrapper2.default.PubSub.publish('closeCartForm', { data: data }, false);
    }
  }, {
    key: 'publishAddToCart',
    value: function publishAddToCart(dataToSend) {
      _WixSdkWrapper2.default.PubSub.publish('ADD_TO_CART', dataToSend, true);
    }
  }, {
    key: '_isNonEmptyArray',
    value: function _isNonEmptyArray(arr) {
      return arr && Array.isArray(arr) && arr.length;
    }
  }, {
    key: '_setInvalidItems',
    value: function _setInvalidItems(arrInvalidItems) {
      var _this6 = this;

      if (this._isNonEmptyArray(arrInvalidItems)) {
        var invalidPromises = [];
        arrInvalidItems.forEach(function (invalidItem) {
          var item = invalidItem.item,
              reason = invalidItem.reason;

          invalidPromises.push(_this6.setItem(item.uuid, (0, _assign2.default)({}, item, { status: reason })));
        });
        return _promise2.default.all(invalidPromises).then(function () {
          _this6.notifyCartChange();
        });
      }
    }
  }, {
    key: '_getInvalidItemsForDownload',
    value: function _getInvalidItemsForDownload(arrCartItems) {
      var _this7 = this;

      return new _promise2.default(function (resolve, reject) {
        var isNonEmptyArray = _this7._isNonEmptyArray(arrCartItems);
        if (isNonEmptyArray) {
          var uniqueIdsToCheck = arrCartItems.reduce(function (previousValue, currentValue) {
            var mediaUrl = currentValue.mediaUrl;


            if (mediaUrl && previousValue.indexOf(mediaUrl) === -1) {
              previousValue.push(mediaUrl);
            }
            return previousValue;
          }, []);

          if (_this7._isNonEmptyArray(uniqueIdsToCheck)) {
            _axios2.default.post('_api/pro-gallery-webapp/v1/items/verification?instance=' + _this7.instance, {
              mediaUrls: uniqueIdsToCheck
            }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
              var result = [];
              var invalidItems = response.data.invalidItems;

              if (_this7._isNonEmptyArray(invalidItems)) {
                invalidItems.forEach(function (invalidItem) {
                  var mediaUrl = invalidItem.mediaUrl,
                      err = invalidItem.err;

                  var arrInvalidCartItems = arrCartItems.filter(function (cartItem) {
                    return cartItem.mediaUrl === mediaUrl;
                  });

                  result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(arrInvalidCartItems.map(function (item) {
                    return { item: item, reason: err || _cartItemsStatuses2.default.INVALID };
                  })));
                });
              }

              resolve(result);
            }).catch(function (err) {
              reject(err);
            });
          } else {
            reject('No ids to check for invalid cart items');
          }
        } else {
          reject('No items to check for invalid cart items');
        }
      });
    }
  }]);
  return CartApi;
}();

var domain = '';
var instance = _windowWrapper2.default.instance;
if (_windowWrapper2.default.instanceId) {
  domain = _windowWrapper2.default.instanceId;
} else {
  try {
    if (_windowWrapper2.default.Wix) {
      domain = _WixSdkWrapper2.default.Utils.getInstanceId();
    } else {
      // We're in a test
      domain = 'test';
    }
  } catch (error) {
    console.log('error domain', error);
  }
}

var cartApi = new CartApi(domain, instance);
module.exports = cartApi;

if (process.env.NODE_ENV === 'development') {
  _windowWrapper2.default.galleryApi = _windowWrapper2.default.galleryApi || {};
  _windowWrapper2.default.galleryApi.cartApi = cartApi;
}